import React from 'react';

export const PauseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M42 5H24V95H42V5Z" />
    <path d="M75 5H57V95H75V5Z" />
  </svg>
);
